import clsx from "clsx"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import Button from "../../../ui/molecules/button"
import { Banner } from "../../../ui/organisms/banner"
import { EditIcon } from "../../../ui/icons/edit"

export function ListM018Customer() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)

    const m024 = {
        id: '1',
        data: '02/02/2022'
    }

    if (sessionState.selected.customerId) {
        return (
            <div className="mt-4">
                <table id="list-table" className="w-[100%]">
                    <thead className="h-[52px] uppercase">
                        <tr>
                            <th style={{ borderTopLeftRadius: '8px' }}>Seleziona</th>
                            <th>Data</th>
                            <th>NC M018</th>
                            <th>Protocollo</th>
                            <th style={{ borderTopRightRadius: '8px' }}>Provvedimenti</th>
                        </tr>
                    </thead>
                    <tbody>
                        <td>
                            <div style={{ display: 'flex', gap: '6px' }}>

                            </div>
                        </td>
                        <td>

                        </td>

                        <td></td>
                        <td></td>
                        <td></td>
                    </tbody>
                </table>
            </div>
        )
    }

    return (
        <Banner
            type="error"
            visible={!sessionState.selected.customerId}
            label={"Devi prima selezionare un cliente per accedere all'area"}
            closeAction={function (): void {
                alert("Devi prima selezionare un cliente per accedere all'area")
            }}
        />
    )

}